import React from "react";
import ReactDOM from "react-dom/client";
import { hydrate, render } from "react-dom";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  // Use hydrate for prerendered content
  hydrate(<App />, rootElement);
} else {
  // Use render for client-side only
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}
